/**
 * Labstep
 *
 * @module components/ExperimentWorkflow/Action/Duplicate
 * @desc Button to duplicate experiment workflow
 */

import { EntityActionDuplicate } from 'labstep-web/components/Entity/Action/Duplicate';
import { ExperimentWorkflow } from 'labstep-web/models/experiment-workflow.model';
import type React from 'react';
import type { ExperimentWorkflowActionDuplicateProps } from './types';

export const ExperimentWorkflowActionDuplicate: React.FC<
  ExperimentWorkflowActionDuplicateProps
> = ({ experimentWorkflow }) => (
  <EntityActionDuplicate
    dataCy="components/ExperimentWorkflow/Action/Duplicate"
    entity={experimentWorkflow}
    body={{
      is_template: experimentWorkflow.is_template,
    }}
    actionComponentProps={{
      type: 'option',
      text: experimentWorkflow.is_template
        ? `Duplicate Template`
        : `Repeat ${ExperimentWorkflow.getHumanReadableEntityName(
            false,
            true,
          )}`,
    }}
  />
);
